import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import XHR from 'i18next-xhr-backend';

import { I18N_API_URL, I18N_LOCALE_DEFAULT, I18N_LOCALE_FALLBACK } from './config/i18n';
i18n.use(initReactI18next) // passes i18n down to react-i18next
    .use(XHR)
    .init(
        {
            lng: I18N_LOCALE_DEFAULT,
            fallbackLng: I18N_LOCALE_FALLBACK,
            react: {
                wait: true
            },
            interpolation: {
                escapeValue: false // react already safes from xss
            },
            backend: {
                crossDomain: true,
                loadPath: I18N_API_URL + 'localization/{{lng}}?dot=true',
                parse: (payload) => JSON.parse(payload).data.content
            }
        },
        (err, t) => {
            if (err) console.error(err);

            const validation = t('form.validation', { returnObjects: true });

            if (typeof validation !== 'string') {
                // set localization for
                // form
                // setLocale(validation);
            }
        }
    );
export default i18n;
